import React from 'react';
import ReactDOMServer from 'react-dom/server.browser';

import { WeightAndBalanceManifest } from './weight-and-balance-manifest';
import { getEvent } from '../../calendar-day.actions';
import { getWeightAndBalance } from '../weight-and-balance.actions';

function* getState() {
  return yield s => s;
}

export const getWeightAndBalanceManifest = dispatch => async () => {
  await dispatch(getEvent());
  await dispatch(getWeightAndBalance());

  const {
    event,
    weightAndBalance,
    user,
    resources,
    timezone,
    activityTypes,
    organization
  } = await dispatch(getState());

  const response = await fetch(weightAndBalance.image);
  const blob = await response.blob();

  if (event.id !== weightAndBalance.eventId) {
    window.location.reload();
  }

  const reverseManifestSeatNumbers = organization && organization.organizationSettings.reverseManifestSeatNumbers === "1";

  return ReactDOMServer.renderToStaticMarkup(
    <WeightAndBalanceManifest
      event={event}
      resources={resources}
      weightAndBalance={weightAndBalance}
      user={user}
      timezone={timezone}
      activityTypes={activityTypes}
      reverseManifestSeatNumbers={reverseManifestSeatNumbers}
      imageBlob={URL.createObjectURL(blob)}
    />
  );
};
